<span [ngClass]="{'text-orange-700 font-bold': displayValue === '—'}">{{ displayValue }}</span>
